import { useContext } from 'react'

import { AircallContext, type AircallContextValue } from './AircallProvider'

/**
 * Access the Aircall integration state and actions from anywhere inside
 * <AircallProvider>. Returns null when the provider isn't mounted (e.g.
 * non-staff users see no Aircall UI) — callers should handle this.
 */
export function useAircall(): AircallContextValue | null {
  return useContext(AircallContext)
}
